import { render, staticRenderFns } from "./taskTypeSelect.vue?vue&type=template&id=46b9e056&"
import script from "./taskTypeSelect.vue?vue&type=script&lang=js&"
export * from "./taskTypeSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports